import { useQuery } from "@tanstack/react-query";
import { meiliClient } from "../../../utils/meiliClient";

/**
 * Finds all keys that start with `questionAnswers_` by sampling one hit.
 * We don't scope by jobId anymore; purely global sample.
 */
export function useQuestionKeys(
  jobId?: string | null,            // kept for compatibility; ignored
  indexName = "applications"
) {
  return useQuery({
    queryKey: ["meiliQuestionKeys", indexName, jobId ?? null],
    queryFn: async () => {
      const index = meiliClient.index(indexName);
      // No filter; just sample one doc
      const res = await index.search("", { limit: 1 });
      const hit = (res.hits as any[])[0] || {};
      const keys = Object.keys(hit || {}).filter((k) =>
        k.startsWith("questionAnswers_")
      );
      return keys
        .map((k) => ({ key: k, label: k.replace(/^questionAnswers_/, "") }))
        .sort((a, b) => a.label.localeCompare(b.label));
    },
  });
}
